import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MiniGuideDataService {
// <p>&#9668; </p>
  static data = {
    courseHistory: {
      title: 'مشاهده نمرات و سوابق تحصیلی',
      guideList: 
        "<p>&#9668; لیست <strong><u>دوره هایی</u></strong> که دانشجو در انها ثبت نام شده است</p>" +
        "<p>&#9668; <strong><u>نمرات</u></strong> ثبت شده توسط استاد برای دانشجو</p>" +
        "<p>&#9668; امکان <strong><u>نظر سنجی</u></strong> برای پکیج های مختلف</p>" +
        "<p>&#9668; <strong><u>سوابق کامل</u></strong> دانشجو از طریق این منو قابل مشاهده است</p>" ,
    },
    studentPlacement: {
      title: 'رزرو و وضعیت تعیین سطح',
      guideList: 
       "<p>&#9668; انجام <strong><u>تعیین سطح</u></strong> برای برخی از پکیج ها جهت ثبت نام</p>" +
       "<p>&#9668; جهت رزرو کردن تعیین سطح</p>" +
       "<p>&#9668; مشاهده تمامی تعیین سطح های انجام شده را امکان پذیر می کند</p>",
    },
    studentRegistration: {
      title: 'ثبت نام دوره های حضوری و انلاین',
      guideList: 
        "<p>&#9668; جهت <strong><u>ثبت نام</u></strong> در دوره های گنبد می بایست از این منو اقدام کنید</p>" +
        "<p>&#9668; بعد از تعیین سطح با توجه به نوع و نتیجه تعیین سطح شما <strong><u>دوره های مختلف</u></strong> برای شما در این بخش نمایش داده خواهد شد</p>",
    },
    studentFinantical: {
      title: 'وضعیت مالی',
      guideList: 
      "<p>&#9668; امکان مشاهده تمامی <strong><u>فاکتور های</u></strong> صادر شده و وضعیت پرداخت انها از طریق دوره های مختلف برای شما در این بخش نمایش داده خواهد شد</p>",
    },
    studentDiscount: {
      title: 'ارسال مدارک درخواست تخفیف',
      guideList:
      "<p>&#9668; چنانچه دانشجو شرابط لازم برای دریافت <strong><u>تخفیف</u></strong> را داشته باشد از طریق این گزینه می تواند اقدام به ارسال مدارک خود نماید</p>",
    }
  }
}
